module.exports = __webpack_public_path__ + "img/4.613c6bb1.png";